import { Location } from 'history'

export function onNavigateAway(nextLocation: Location | undefined, unsavedChanges: boolean) {
    if (!nextLocation) {
        return unsavedChanges
    }
    const leavingStudio = nextLocation.pathname.indexOf('home') > -1
    return unsavedChanges && leavingStudio
}
